import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { memo, useEffect, useState } from 'react';

import DashboardMenu from './dashboards/DashboardMenu';
// import useAuth from 'hooks/useAuth';
import useSearch from 'hooks/useSearch';
import useSetQuery from 'hooks/useSetQuery';
import useMenu from 'hooks/useMenu';
import useTopPanel from 'hooks/useTopPanel';
import DateTypeSelectFilter from 'components/dashboard/items/dateTypeSelectFilter';
import ObjectSelectBox from 'components/boss/ObjectSelectBox';
import StaffsMultiSelect from 'components/dashboard/items/StaffsMultiSelect';
import ShareWidgets from '../ShareWidgets';

const CRMTopPanel = ({
  addBlock = false,
  openSettings = false,
  setOpenSettings = () => {},
  setOpenWidgetModal = () => {},
}) => {
  const { t, i18n } = useTranslation();
  const { setComponent } = useTopPanel();
  const [openShare, setOpenShare] = useState(false);
  const query = useSearch();
  const setQuery = useSetQuery();
  // const [{ user }] = useAuth();
  const { hasChild } = useMenu();

  const view = (code) => hasChild('DASHBOARD', code);

  useEffect(() => {
    setComponent(
      <div className='component-title'>
        {t('dashboard.title')}
        {view('SHARE_DASHBOARD') && (
          <Button
            variant='base'
            onClick={() => setOpenShare(true)}
            color='info'
            className='!ml-4 !w-8 !h-8 !px-[6px]'
          >
            <i className='bi bi-folder-symlink' />
          </Button>
        )}
      </div>
    );
  }, [i18n.language]);

  return (
    <div className='crm-top-panel-wrapper  min-h-[56px] !w-[calc(100%+32px)] px-4 bg-[#F8F9FB] border-b border-b-[#E5E9EB] -mt-2 -ml-4 !-mr-4'>
      <DashboardMenu
        addAllowed={view('ADD_DASHBOARD')}
        openSettings={openSettings}
      />

      <div className='flex justify-end grow ml-24 items-center gap-3 [&>*]:!whitespace-nowrap'>
        {/* {view('CRM_ADD_BLOCK_ITEM') && ( */}
        <div className='w-[200px]'>
          <ObjectSelectBox
            value={query.get('object_id') || 'ALL'}
            setValue={(id) => setQuery('object_id', id !== 'ALL' ? id : null)}
          />
        </div>
        <div className='w-[250px]'>
          <StaffsMultiSelect />
        </div>
        <div className='w-[200px]'>
          <DateTypeSelectFilter />
        </div>
        {view('ADD_WIDGET') && (
          <Button
            variant='base'
            onClick={() => setOpenWidgetModal((prv) => !prv)}
            color='info'
            startIcon={<i className='bi bi-grid' />}
          >
            {t('dashboard.widgetSettings')}
          </Button>
        )}
        <Button
          variant='base'
          onClick={() => setOpenSettings((prv) => !prv)}
          color='info'
          startIcon={<i className='bi bi-gear' />}
        >
          {t('settings.title')}
        </Button>

        {/*  )} */}
      </div>

      {openShare && <ShareWidgets open={openShare} setOpen={setOpenShare} />}

      {openSettings && (
        <div className='flex grow justify-end gap-3'>
          <Button
            variant='contained'
            color='success'
            size='small'
            onClick={() => setOpenSettings(false)}
            // disabled={isSubmitting}
            className='!bg-[#FF6D6D] !font-normal'
          >
            {t('common.button.cancel')}
          </Button>
          <Button
            color='success'
            variant='contained'
            size='small'
            className='!bg-[#16BA5C] !mr-2 !font-normal'
            // onClick={() => sendComment()}
            // disabled={isSubmitting}
          >
            {/* {isSubmitting && (
                    <CircularProgress
                      size={15}
                      color='inherit'
                      className='mr-1'
                    />
                  )} */}
            {t('common.button.save')}
          </Button>
        </div>
      )}
    </div>
  );
};
export default memo(CRMTopPanel);
